"use client";

import { c as _c } from "react/compiler-runtime";
import { Filters } from "@/types/filters";
import { countActiveFilters } from "@/utils/search/count-active-filters";
import { formatSlugToTitle } from "@/utils/string/slug-to-title";
import { useEffect } from "react";
export function SearchTitleUpdater(t0) {
  const $ = _c(3);
  const {
    filters
  } = t0;
  let t1;
  let t2;
  if ($[0] !== filters) {
    t1 = () => {
      const activeFiltersCount = countActiveFilters(filters);
      const firstLocation = filters.locations?.[0];
      if (activeFiltersCount === 1 && firstLocation?.name) {
        const locationName = formatSlugToTitle(firstLocation.name).replace("Project", "").trim();
        const delayedTitle = `${locationName} - 0 brokerage Properties`;
        const timeoutId = setTimeout(() => {
          document.title = delayedTitle;
        }, 5000);
        return () => clearTimeout(timeoutId);
      }
    };
    t2 = [filters];
    $[0] = filters;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  return null;
}